
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { useState, useEffect } from 'react';
import { SlippageMode, SlippageSettings, DEFAULT_SLIPPAGE } from '../types/slippage';

const STORAGE_KEY = 'hot_slippage_settings';

export const useSlippage = () => {
    const [settings, setSettings] = useState<SlippageSettings>(() => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            return stored ? JSON.parse(stored) : { mode: 'AUTO', value: DEFAULT_SLIPPAGE };
        } catch {
            return { mode: 'AUTO', value: DEFAULT_SLIPPAGE };
        }
    });

    const setSlippage = (value: number) => {
        const newSettings: SlippageSettings = { mode: 'CUSTOM', value };
        setSettings(newSettings);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newSettings));
    };

    const setAutoSlippage = () => {
        const newSettings: SlippageSettings = { mode: 'AUTO', value: DEFAULT_SLIPPAGE };
        setSettings(newSettings);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newSettings));
    };

    return {
        ...settings,
        setSlippage,
        setAutoSlippage,
        isAuto: settings.mode === 'AUTO'
    };
};
